import { chooseObjectForReadonly } from "../utils/codeSplit";
import normalRootReducer, {
  displayCacheReducer as normalDisplayCacheReducer,
  validatedReducer as normalValidatedReducer
} from "./rootReducer.normal";
import readonlyRootReducer, {
  displayCacheReducer as readonlyDisplayCacheReducer,
  validatedReducer as readonlyValidatedReducer
} from "./rootReducer.readonly";

const validatedReducer = chooseObjectForReadonly(readonlyValidatedReducer, normalValidatedReducer);

const displayCacheReducer = chooseObjectForReadonly(readonlyDisplayCacheReducer, normalDisplayCacheReducer);

const chosenReducer = chooseObjectForReadonly(readonlyRootReducer, normalRootReducer);

export { displayCacheReducer, validatedReducer };
export default chosenReducer;
